import React from "react";
import { Container, Row, Col, Navbar, Nav, Button, Card, Form } from "react-bootstrap";
import { motion } from "framer-motion";
import WebAgendamento from "../../WebAgendamento";

export default function SalonTemplate({ children, dadosEmpresa, enderecoC }) {
  const primary = "#4A5568";      // Cinza neutro principal
  const secondary = "#718096";    // Cinza médio para contornos
  const background = "#F7F8FA";   // Cinza claro suave
  console.log(dadosEmpresa)

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Agendamento solicitado — integre com sua API aqui.");
  };

  return (
    <>
      {/* NAVBAR */}
      <Navbar bg="light" expand="lg" className="shadow-sm py-3 weabagenda">
        <Container>
          <Navbar.Brand className="fw-bold" style={{ color: primary }}>
            {(dadosEmpresa?.logo != "" && <img
              style={{ maxWidth: "63px", marginRight: "15px" }}
              src={dadosEmpresa?.logo}
            />)}

            {dadosEmpresa?.nome}
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Nav>
              {
              /*<Nav.Link href="#sobre">Sobre</Nav.Link>
              <Nav.Link href="#servicos">Serviços</Nav.Link>
              <Nav.Link href="#galeria">Galeria</Nav.Link>
             
               <Nav.Link href="#contato">Contato</Nav.Link>
              
              <Button variant="outline-secondary" className="ms-2">
                Agendar
              </Button> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* HERO */}
      {/*   <header className="py-5" style={{ background: background }}>
          {/*  <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <motion.h1
                className="display-5 fw-bold"
                style={{ color: primary }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
              >
                Qualidade, profissionalismo e praticidade no seu atendimento
              </motion.h1>

              <p className="lead text-muted">
                Atendimento moderno, confortável e voltado para sua melhor experiência.
              </p>

              <div className="d-flex gap-2">
                <Button
                  style={{ background: primary, borderRadius: 30, borderColor: primary }}
                  href="#agendamento"
                >
                  Marcar agora
                </Button>
                <Button variant="outline-secondary">Ver Galeria</Button>
              </div>
            </Col>

            <Col lg={6} className="text-center">
              <motion.img
                src="https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?q=80&w=1200"
                alt="hero"
                className="img-fluid rounded shadow"
                style={{ maxHeight: 420, objectFit: "cover" }}
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 }}
              />
            </Col>
          </Row>
        </Container>
      </header>
*/}
      {children}
      {/* SOBRE */}
      {/*} <section id="sobre" className="py-5">
        <Container>
          <Row className="align-items-center g-4">
            <Col md={6}>
              <motion.img
                src="https://images.unsplash.com/photo-1500835556837-99ac94a94552?q=80&w=1200"
                className="img-fluid rounded shadow"
                alt="Sobre"
                initial={{ opacity: 0, x: -40 }}
                whileInView={{ opacity: 1, x: 0 }}
              />
            </Col>
            <Col md={6}>
              <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}>
                <h2 className="mb-3" style={{ color: primary }}>Sobre nós</h2>
                <p className="text-muted">
                  Somos uma empresa comprometida com excelência, atendimento humanizado e
                  serviços de qualidade. Nossa missão é oferecer uma experiência tranquila,
                  profissional e moderna para todos os clientes.
                </p>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>*/}

      {/* SERVIÇOS */}
      {/*   <section id="servicos" className="py-5">
        <Container>
          <h2 className="h3 mb-4" style={{ color: primary }}>Nossos serviços</h2>
          <Row className="g-4">
            {[
              { title: "Serviço 1", img: "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?q=80&w=600" },
              { title: "Serviço 2", img: "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?q=80&w=600" },
              { title: "Serviço 3", img: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?q=80&w=600" },
            ].map((s, i) => (
              <Col md={4} key={i}>
                <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}>
                  <Card className="h-100 shadow-sm">
                    <img
                      src={s.img}
                      className="card-img-top"
                      style={{ height: 180, objectFit: "cover" }}
                    />
                    <Card.Body>
                      <Card.Title style={{ color: primary }}>{s.title}</Card.Title>
                      <Card.Text className="text-muted">
                        Descrição breve do serviço oferecido pela empresa.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>*/}

      {/* GALERIA */}
      {/* <section id="galeria" className="py-5 bg-light">
        <Container>
          <h2 className="h3 mb-4" style={{ color: primary }}>Galeria</h2>
          <Row className="g-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <Col sm={6} md={4} key={i}>
                <motion.img
                  src={`https://picsum.photos/600/400?random=${i + 1}`}
                  className="img-fluid rounded shadow-sm"
                  style={{ height: 220, objectFit: "cover" }}
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </section>*/}

      {/* AGENDA */}

      {/* RODAPÉ */}
      <footer className="py-4 bg-dark text-light">
        <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div>
            <strong>{dadosEmpresa?.nome}</strong><br />{enderecoC}
          </div>
        </Container>
        <Container className="">
        <div className="text-center">
          {(dadosEmpresa?.celular) && <>
            WhatsApp: {dadosEmpresa?.celular}<br />
          </>}

          <small>© {new Date().getFullYear()}</small>
        </div>
      </Container>
    </footer >

      {/* CTA WHATSAPP */ }

  {
    (dadosEmpresa?.celular) &&
    <motion.a
      href={`https://wa.me/${dadosEmpresa?.celular}`}
      target="_blank"
      className="position-fixed"
      style={{
        bottom: 25,
        right: 25,
        background: "#25D366",
        padding: "14px 17px",
        borderRadius: "50%",
        color: "#fff",
        fontSize: 24,
        textDecoration: "none",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
      }}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4 }}
    >
      💬
    </motion.a>
  }
    </>
  );
}
